import { waitForContent } from "../shared/utility";
import { initializePage } from "../shared/page-init";
import { validatePage } from "../shared/validation";
import { previous } from "../shared/navigation";
import { renderNavButtons, renderQuestionOkNotOk, renderQuestionOkNotOkNa } from "../shared/templates";

const app = window.app;

export class MbRoad extends HTMLElement {
	async connectedCallback() {
		await waitForContent("mbRoad");

		this.innerHTML = app.content.mbRoad;

		// Render the navigation buttons component
		this.querySelector("#nav-slot").replaceWith(renderNavButtons("backButton12", "nextButton12"));

		//prettier-ignore
		const questions = [
			["mer-key-function",    "Key function and keyless entry",   false       ],
			["mer-idle",            "Idle quality, vibrations",         false       ],
			["mer-engine",          "Engine performance, noise",        false       ],
			["mer-shift",           "Shift quality (in C, S, S+)",      false       ],
			["mer-steering",        "Steering wheel straight",          false       ],
			["mer-steering-vib",    "Steering wheel vibrations",        false       ],
			["mer-traction",        "Traction control on/off",          false       ],
			["mer-heads-up",        "Heads-up display",                 true        ],
			["mer-cruise-control",  "Cruise control",                   false       ],
			["mer-lane-assist",     "Lane keeping assist+",             false       ],
			["mer-lane-change",     "Automatic lane change+",           true        ],
			["mer-blind-assist",    "Blind spot assist",                false       ],
			["mer-360",             "360 back-up camera functional",    false       ],
			["mer-parking-sensor",  "Parking sensor functional",        false       ],
			["mer-brake-performance","Brake noises/performance",        false       ],
			["mer-parking-brake",   "Parking brake functional",         false       ],
			["mer-wipers",          "Wiper and spray functional",       false       ],
			["mer-ac",              "AC function: auto and blower",     false       ],
			["mer-service-errors",  "Error/service messages",           false       ],
			["mer-rattles",         "Rattles/squeaks",                  false       ],
		];

		for (const [name, label, na] of questions) {
			const render = na ? renderQuestionOkNotOkNa : renderQuestionOkNotOk;
			this.querySelector(`#${name}-slot`).replaceWith(render(name, label, 12));
		}

		this.addEventListener("ionViewWillEnter", async () => {
			const pageElement = this;
			await initializePage(12, pageElement);
		});

		this.addEventListener("ionViewDidEnter", async () => {
			// Add event listener to open Driver Assistance PDF in new tab
			const link = document.getElementById("driver-assist-link");
			if (link) {
				link.addEventListener("click", (e) => {
					e.preventDefault();
					// Open PDF in new tab
					window.open(link.getAttribute("href"), "_blank");
				});
			}
			const currentRoute = app.routes.mbRoad;
			const nextPage = app.flowManager.getNext(currentRoute);
			const prevPage = app.flowManager.getPrevious(currentRoute);

			if (prevPage) app.state.backButton.addEventListener("click", () => previous(prevPage.route));
			if (nextPage) app.state.nextButton.addEventListener("click", () => validatePage(nextPage.route));
		});
	}
}
